var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseIconRoundFilledGrey(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    fill: "black",
    fillOpacity: 0.36
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9393 16.0001L21.1393 11.8068C21.2648 11.6813 21.3354 11.511 21.3354 11.3335C21.3354 11.1559 21.2648 10.9857 21.1393 10.8601C21.0138 10.7346 20.8435 10.6641 20.666 10.6641C20.4884 10.6641 20.3182 10.7346 20.1926 10.8601L15.9993 15.0601L11.806 10.8601C11.6804 10.7346 11.5102 10.6641 11.3326 10.6641C11.1551 10.6641 10.9848 10.7346 10.8593 10.8601C10.7338 10.9857 10.6632 11.1559 10.6632 11.3335C10.6632 11.511 10.7338 11.6813 10.8593 11.8068L15.0593 16.0001L10.8593 20.1935C10.7968 20.2554 10.7472 20.3292 10.7134 20.4104C10.6795 20.4916 10.6621 20.5788 10.6621 20.6668C10.6621 20.7548 10.6795 20.8419 10.7134 20.9232C10.7472 21.0044 10.7968 21.0781 10.8593 21.1401C10.9213 21.2026 10.995 21.2522 11.0763 21.2861C11.1575 21.3199 11.2446 21.3373 11.3326 21.3373C11.4206 21.3373 11.5078 21.3199 11.589 21.2861C11.6703 21.2522 11.744 21.2026 11.806 21.1401L15.9993 16.9401L20.1926 21.1401C20.2546 21.2026 20.3284 21.2522 20.4096 21.2861C20.4908 21.3199 20.578 21.3373 20.666 21.3373C20.754 21.3373 20.8411 21.3199 20.9224 21.2861C21.0036 21.2522 21.0773 21.2026 21.1393 21.1401C21.2018 21.0781 21.2514 21.0044 21.2852 20.9232C21.3191 20.8419 21.3365 20.7548 21.3365 20.6668C21.3365 20.5788 21.3191 20.4916 21.2852 20.4104C21.2514 20.3292 21.2018 20.2554 21.1393 20.1935L16.9393 16.0001Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIconRoundFilledGrey);
export default __webpack_public_path__ + "static/media/close-icon-round-filled-grey.7cddc45bd28743604d17dfb6f5af7adc.svg";
export { ForwardRef as ReactComponent };